import React from 'react';
import { createRoot } from 'react-dom/client';
import 'assets/sass/main.scss';
import App from 'App.js';
import * as serviceWorker from 'serviceWorker';

import store from './store';
import { Provider } from 'react-redux';

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

serviceWorker.unregister();